// Shared escaping helpers. Everything that lands inside an innerHTML template
// goes through one of these — content comes from the CMS and from visitors, and
// neither is trusted markup.
(function () {
  const HTML_ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

  // Text or attribute values inside double quotes.
  function esc(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/[&<>"']/g, ch => HTML_ENTITIES[ch]);
  }

  // URLs used in href / src. Blocks javascript: and data: payloads.
  function escUrl(value) {
    const raw = String(value === null || value === undefined ? '' : value).trim();
    if (/^(javascript|data|vbscript):/i.test(raw.replace(/\s/g, ''))) return '#';
    return esc(raw);
  }

  // URLs dropped into a CSS url(...) inside a style attribute. Anything that
  // could close the url() or the attribute is rejected outright.
  function escCssUrl(value) {
    const raw = String(value === null || value === undefined ? '' : value).trim();
    if (!raw) return '';
    if (/["'()\\;]|^\s*(javascript|vbscript):/i.test(raw)) return '';
    return esc(raw);
  }

  // style="background-image:url(...)" builder used by every card renderer.
  function bgStyle(url, pos) {
    const safe = escCssUrl(url);
    if (!safe) return '';
    const position = Number.isFinite(Number(pos)) ? Number(pos) : 50;
    return `background-image:url(${safe});background-position:center ${position}%`;
  }

  window.esc = esc;
  window.escUrl = escUrl;
  window.escCssUrl = escCssUrl;
  window.bgStyle = bgStyle;
})();
